module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('section', {
    ref: "block",
    staticClass: "Masthead",
    style: ({
      height: _vm.sectionHeight + 'vh'
    })
  }, [_c('div', {
    ref: "parallax",
    staticClass: "Masthead__image",
    class: {
      'is-parallax': _vm.parallax, 'is-fixed': _vm.fixed
    }
  }, [_vm._t("default")], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cfd1a30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Parallax.vue
// module id = 7
// module chunks = 1